export default __webpack_public_path__ + "static/media/16 [Converted]@2x.e656f630.png";